/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { replaceSubdomain } from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import {
  CodesListData,
  CodesListItemData,
  CodeAddData,
  PoolCreateData,
  PoolShowData,
  PoolsListData,
  PoolsListItemData, CodesReserveData, CodeCommentUpdateData, CodesIssueData, CodesSendData
} from '../types'

const procodesBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_PROCODES)

export const CodesStatusList = ['available', 'claimed', 'redeemed', 'reserved', 'sent'] // !fixme: should be moved to shared constants

export const procodesClient = axios.create({
  baseURL: procodesBaseURL
})

export const poolBehaviorsList = ['limited'] // fixme!

export function fetchPoolsList (param: string): Promise<PoolsListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    procodesClient.get(`/pools${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchPoolById (id: string): Promise<PoolShowData> {
  return new Promise((resolve, reject) => {
    procodesClient.get(`/pools/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createPool (pool: PoolCreateData): Promise<PoolsListItemData> {
  return new Promise((resolve, reject) => {
    procodesClient.post('/pools', pool)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updatePool (pool: PoolCreateData, id: string): Promise<PoolsListItemData> {
  return new Promise((resolve, reject) => {
    procodesClient.put(`/pools/${id}`, pool)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchCodesList (param: string, id: string): Promise<CodesListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    procodesClient.get(`/pools/${id}/codes${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function addCode (code: CodeAddData, id: string): Promise<CodesListItemData> {
  return new Promise((resolve, reject) => {
    procodesClient.post(`/pools/${id}/codes`, code)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function generateCodes (param: any, id: string): Promise<CodesListItemData> {
  return new Promise((resolve, reject) => {
    procodesClient.put(`/pools/${id}/codes`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function refreshPoolsStatistics (): Promise<PoolsListData> {
  return new Promise((resolve, reject) => {
    procodesClient.put('/pools/stats')
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function sendCodesToEmail (param: any, id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.post(`/pools/${id}/codes/reserve-send`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function reserveCodes (param: CodesReserveData, id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.post(`pools/${id}/codes/reserve`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchReservedCodesList (status: string): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.get(`/codes/${status}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updateCodeComment (param: CodeCommentUpdateData, id: string): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.put(`/codes/${id}/comment`, param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function issueCodes (param: CodesIssueData): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.put('/codes/issue', param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function sendCodes (param: CodesSendData): Promise<any> {
  return new Promise((resolve, reject) => {
    procodesClient.post('/codes/send', param)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchPoolsList,
  fetchPoolById,
  createPool,
  updatePool,
  fetchCodesList,
  addCode,
  generateCodes,
  refreshPoolsStatistics,
  sendCodesToEmail,
  reserveCodes,
  fetchReservedCodesList,
  updateCodeComment,
  issueCodes,
  sendCodes
}
